module.exports = __webpack_public_path__ + "img/tkbet.b30106a8.png";